import { Link } from "react-router-dom";
import { Target } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="mt-16 border-t border-black/5 bg-[#FAF7F2] text-slate-700">
      <div className="max-w-md mx-auto sm:max-w-2xl lg:max-w-4xl px-4 sm:px-6 py-10">
        <div className="flex flex-col gap-6">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-8 h-8 rounded-full grid place-items-center bg-white border border-[#F04E1E]/30">
                <Target className="w-4 h-4 text-[#F04E1E]" strokeWidth={2.5} />
              </span>
              <h4 className="font-display font-black text-xl">
                <span className="text-black">JUWAI</span>{" "}
                <span className="text-[#F04E1E]">MORNING TEER</span>
              </h4>
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">
              Juwai Morning Teer is an informational website. We do not operate,
              organize, promote, sell tickets for, or facilitate betting or
              gambling. Results and other information are provided for
              informational/reference purposes only.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-3 text-sm font-semibold">
            <Link
              to="/about"
              className="text-slate-700 hover:text-[#F04E1E] transition-colors"
              data-testid="footer-about"
            >
              About Us
            </Link>
            <Link
              to="/contact"
              className="text-slate-700 hover:text-[#F04E1E] transition-colors"
              data-testid="footer-contact"
            >
              Contact
            </Link>
            <Link
              to="/privacy-policy"
              className="text-slate-700 hover:text-[#F04E1E] transition-colors"
              data-testid="footer-privacy"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-slate-700 hover:text-[#F04E1E] transition-colors"
              data-testid="footer-terms"
            >
              Terms
            </Link>
            <Link
              to="/disclaimer"
              className="text-slate-700 hover:text-[#F04E1E] transition-colors"
              data-testid="footer-disclaimer"
            >
              Disclaimer
            </Link>
            <Link
              to="/juwai-morning-teer"
              className="text-slate-700 hover:text-[#F04E1E] transition-colors"
              data-testid="footer-info"
            >
              About Teer
            </Link>
          </div>
          <div className="pt-4 border-t border-black/10 text-xs text-slate-500">
            © {new Date().getFullYear()} Juwai Morning Teer. All rights
            reserved. For informational purposes only.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
